import { Model } from "@bryntum/schedulerpro";

export class BoardClientAgenda extends Model {
  static get $name() {
    return "BoardClientAgenda";
  }

  static get fields() {
    return [
      { name: "boardId", dataSource: "board" },
      { name: "companyName", dataSource: "company_name" },
      { name: "agendaTitle", dataSource: "agenda_title" },
      { name: "notes" },
      {
        name: "includeResource",
        dataSource: "include_resource",
        type: "boolean"
      },
      {
        name: "includeResourceContact",
        dataSource: "include_resource_contact",
        type: "boolean"
      }
    ];
  }
}

BoardClientAgenda.exposeProperties();
